export enum Category {
  None,
  Audit,
  CorporateGovernance,
  Csr,
  VotingResults,
  Compensation,
  Accounting
}
